export const FEATURE_GATES = {
  AUTH_VIA_ENTRA_ID: "auth_via_entra_id"
} as const;

export type FeatureGateName =
  (typeof FEATURE_GATES)[keyof typeof FEATURE_GATES];
